import { doPost2, API } from 'services/common'
import { getUtmParameters } from 'util/utm'

//Utility function to run JSON.parse without failing method, due to some returned data inconsistencies
const isJSON = str => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

/*
    returns a promise and a payload
    {
        success: Boolean
        message: String
        profile: Object
    }

    on the server side Spring Security supplies the endpoint, so we can't
    dictate the request parameter format (URLSearchParams)
*/
export const login = async (username, password, visitorId, seekEmail) => {
  const data = {
    username: username,
    password: password,
    'remember-me': true,
    visitorId,
    seekEmail: seekEmail || null,
  }

  try {
    const response = await API.doPost2('/user/login', data)
    if (response.status === 200) {
      const token = response.headers.get('x-token')
      API.setToken(token)

      const json = await response.json()

      return {
        success: true,
        profile: json,
      }
    } else if (response.status === 401) {
      return {
        success: false,
        message: 'Incorrect username or password',
      }
    } else {
      return {
        success: false,
        message: 'Unexpected error',
      }
    }
  } catch (e) {
    return {
      success: false,
      message:
        'Unable to communicate with server. Please check your internet connection.',
    }
  }
}

/*
    returns a promise and a payload
    {
        success: Boolean
        message: String
    }
*/

export const logout = async () => {
  try {
    await doPost2(`/user/logout`)
    API.setToken(null)
    return {
      success: true,
    }
  } catch (e) {
    return new Promise((resolve, reject) => {
      reject({
        success: false,
        message:
          'Unable to communicate with server. Please check your internet connection.',
      })
    })
  }
}

/*
    returns a promise and a payload
    {
        success: Boolean
        message: String
        profile: Object
    }
*/

// Returns a random integer between min (inclusive) and max (inclusive).
// function getRandomInt(min, max) {
//     min = Math.ceil(min);
//     max = Math.floor(max);
//     return Math.floor(Math.random() * (max - min + 1)) + min;
// }

export const register = async ({
  email,
  password,
  turnstileToken,
  turnstileTokenType = 'visible',
  birthDate,
  gender,
  storeIds,
  visitorId,
  seekEmail,
}) => {
  const params = {
    firstName: '',
    lastName: '',
    email,
    password,
    passwordConfirm: password,
    birthDate,
    gender,
    storeIds,
    turnstileToken,
    turnstileTokenType,
    'remember-me': true,
    visitorId,
    seekEmail: seekEmail || null,
    // honeyPotField
  }

  const utms = await getUtmParameters()

  const payload = Object.assign({}, params, utms?.parameters)

  // console.log(params)

  try {
    const response = await doPost2(`/user/register`, payload)

    return response.text().then(data => {
      const resData = isJSON(data) ? JSON.parse(data) : data
      if (response.status !== 200) {
        return {
          status: response.status,
          success: response.ok,
          detail: resData,
        }
      } else {
        const token = response.headers.get('x-token')
        API.setToken(token)
        const hasError = !!resData.error || false
        return {
          hasError: hasError,
          status: response.status,
          success: hasError ? false : response.ok,
          detail: resData,
        }
      }
    })
  } catch (e) {
    return new Promise((resolve, reject) => {
      // eslint-disable-line no-unused-vars
      reject({
        success: false,
        status: -1,
        message:
          'Unable to communicate with server. Please check your internet connection.',
      })
    })
  }
}

export const registerLoyalty = async params => {
  try {
    const response = await doPost2(`/user/registerLoyalty`, params)

    return response.text().then(data => {
      const resData = isJSON(data) ? JSON.parse(data) : data
      if (response.status !== 200) {
        return {
          status: response.status,
          success: response.ok,
          detail: resData,
        }
      } else {
        const token = response.headers.get('x-token')
        API.setToken(token)
        const hasError = !!resData.error || false
        return {
          hasError: hasError,
          status: response.status,
          success: hasError ? false : response.ok,
          detail: resData,
        }
      }
    })
  } catch (e) {
    return new Promise((resolve, reject) => {
      // eslint-disable-line no-unused-vars
      reject({
        success: false,
        status: -1,
        message:
          'Unable to communicate with server. Please check your internet connection.',
      })
    })
  }
}

export const registerGuest = async () => {
  try {
    const response = await API.doPost2('/user/registerGuest')
    if (response.status === 200) {
      const token = response.headers.get('x-token')
      API.setToken(token)

      const data = await response.json()
      return {
        status: response.status,
        success: response.ok,
        detail: data,
      }
    }
  } catch (e) {
    return new Promise((resolve, reject) => {
      // eslint-disable-line no-unused-vars
      reject({
        success: false,
        status: -1,
        message:
          'Unable to communicate with server. Please check your internet connection.',
      })
    })
  }
}

export const tokenLogin = async token => {
  const payload = {
    token: token,
  }

  const response = await doPost2(`/user/tokenLogin`, payload)
  const clone = response.clone()

  if (response.status === 200) {
    const token = response.headers.get('x-token')
    API.setToken(token)
  }

  return clone
}
